import { render, staticRenderFns } from "./SupplierAudit.vue?vue&type=template&id=0dd65190&"
import script from "./SupplierAudit.vue?vue&type=script&lang=js&"
export * from "./SupplierAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports